import { getDashboardTopRevenueApi } from 'app/services/homePageApi';
import React, { useMemo } from 'react';
import {
  DASHBOARD_REPORT_TYPE,
  toRankingRows,
  useDashboardReport,
} from '../hooks/useDashboardReport';
import TopRankingReport, { BLUE_SCALE } from './TopRankingReport';

interface ITopStaffReportProps {
  translations: any;
}

export function TopStaffReport(props: ITopStaffReportProps) {
  const { translations } = props;
  const { rows, period, onChangePeriod, isLoading } = useDashboardReport({
    actionApi: getDashboardTopRevenueApi,
    type: DASHBOARD_REPORT_TYPE.AGENT,
  });

  const data = useMemo(() => toRankingRows(rows), [rows]);

  return (
    <TopRankingReport
      translations={translations}
      title={translations?.['b2b.txt.topSalesRepresentatives'] ?? ''}
      data={data}
      colorScale={BLUE_SCALE}
      period={period}
      onChangePeriod={onChangePeriod}
      isLoading={isLoading}
    />
  );
}

export default TopStaffReport;
